<template>
  <div :class="auth.authenticated ? `` : `container-fluid`">
    <signed-in v-if="auth.authenticated" />
    <not-signed-in v-if="!auth.authenticated" />
    <flash v-if="flash.active" />
    <app-tour />
  </div>
</template>
<script>
import { mapState } from "vuex";
import SignedIn from "@/layouts/SignedIn.vue";
import NotSignedIn from "@/layouts/NotSignedIn.vue";
import Flash from "@/components/global/Flash";
import AppTour from "./components/AppTour.vue";

export default {
  components: {
    SignedIn,
    Flash,
    NotSignedIn,
    AppTour,
  },
  computed: {
    ...mapState(["auth", "flash"]),
  },
};
</script>
<style lang="scss">
@import "./assets/styles/app.scss";
</style>
<style scoped>
@import "./assets/dashkit/assets/fonts/feather/feather.css";
@import "./assets/dashkit/assets/css/theme.min.css";
</style>
